<template>
  <!--個人信息-->
  <div>
    <div class="loadingInf">
      {{$t('mall_profile.user_infor')}}<!-- 個人信息 -->
    </div>
    <div>

      <div class="gender rowDiv">
        <div>
          <div class="title">
            {{$t('mall_self_page.appellation')}}<!-- 稱謂  -->
            <span class="star">*</span>
          </div>
          <div class="rowDiv">
            <el-radio v-model="params.sex" label="1">{{$t('mall_self_page.man')}}<!-- 先生 --></el-radio>
            <el-radio v-model="params.sex" label="0">{{$t('mall_self_page.woman')}}<!-- 女士 --></el-radio>
          </div>

        </div>
        <div></div>
      </div>
      <div class="rowDiv">
        <div>
          <div class="title"> {{$t('mall_self_page.first_name')}}<!-- 姓 --> <span class="star">*</span></div>
          <el-input ref="first_name" v-model="params.first_name" :placeholder="$t('mall_self_page.input_first_name')"></el-input>
        </div>
        <div style="width: 50px"></div>
        <div>
          <div>
            <div class="title"> {{$t('mall_self_page.last_name')}}<!-- 名 --> <span class="star">*</span></div>
            <el-input ref="last_name" v-model="params.last_name" :placeholder="$t('mall_self_page.input_last_name')"></el-input>
          </div>
        </div>
      </div>
      <div class="rowDiv">
        <div>
          <div class="title"> {{$t('mall_self_page.birthday')}}<!-- 生日 --> </div>
          <el-date-picker
            ref="birthday"
            v-model="params.birthday"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :placeholder="$t('mall_self_page.select_date')">
          </el-date-picker>
        </div>
        <div style="width: 50px"></div>
        <div>
          <div class="title"> {{$t('mall_self_page.email')}}<!-- 电子邮箱 --> <span class="star">*</span></div>
          <el-input ref="email" v-model="params.email" :placeholder="$t('mall_self_page.input_email')" @keyup.enter.native="save"> </el-input>
        </div>
      </div>

      <div class="btns rowDiv">
        <button class="pointer giveUp" @click="cancel">{{$t('mall_self_page.cancel')}}<!-- 放棄修改 --></button>
        <button class="pointer save" @click="save">{{$t('mall_self_page.save')}}<!-- 保存 --></button>
        <div style="width: 340px"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import { AreaCascader } from "vue-area-linkage"
  import Validator from '@/assets/js/Validator';
  export default {
    name: "SelfPage",
    data(){
      return {
        params: {
          sex: '1',
          first_name: '',
          last_name: '',
          email: '',
          birthday: '',
        },
      }
    },
    methods:{
      cancel() {
        window.history.go(-1);
      },
      save() {
        if (this.formValidator()) {
          this.params.sex = parseInt(this.params.sex);
          this.$axios.put('mall_api/customer_info', this.params).then(res => {
            this.$notify.success({
              message:this.$t('mall_self_page.success_changed') //'修改成功'
            });
            this.getData();
          });
        }
      },
      formValidator() {
        if (!this.params.first_name) {
          this.$notify.error({
            message:this.$t('mall_self_page.input_first_name') // '請填寫姓氏'
          });
          this.$refs.first_name.focus();
          return false;
        }
        if (!this.params.last_name) {
          this.$notify.error({
            message: this.$t('mall_self_page.input_last_name')//'請填寫名字'
          });
          this.$refs.last_name.focus();
          return false;
        }
        if (!this.params.birthday) {
          this.$notify.error({
            message: this.$t('mall_self_page.input_birth')//'請填寫生日'
          });
          this.$refs.birthday.focus();
          return false;
        }
        if (!Validator('email',{ email: this.params.email })) {
          return false;
        }
        return true;
      },
      getData() {
        this.$axios.get('mall_api/customer_info').then(res => {
          this.params = res.data.data;
          this.params.sex = this.params.sex.toString()
        });
      }
    },
    created() {
      this.getData();
    }
  }
</script>

<style lang="less" scoped>
  .loadingInf {
    color: #1E1303;
    font-size: 18px;
    border-bottom: 1px solid #ddd;
    padding-bottom: 10px;
    margin-bottom: 20px;
  }
  .title {
    color: #5B5957;
    font-size: 14px;
    padding: 8px 0;
  }
  .star {
    color: #BF4444;
  }
  .btns {
    display: flex;
    justify-content: flex-end;
    height: 50px;
    margin-top: 80px;
  }
  .btns>button {
    width: 166px !important;
    height: 100%;
    text-align: center;
    border: 1px solid #ddd;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    font-size: 16px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
  }
  .giveUp {
    color: #1E1303;
    border-color: #1E1303!important;
    margin-right: 20px;

  }
  .save {
    background-color: #1E1303;
    color: #fff;
  }
  .rowDiv {
    display: flex;
    padding: 8px 0;
  }
  .rowDiv>div {
    width: 220px;
  }

  /deep/ .gender .el-radio__input.is-checked .el-radio__inner {
    border-color: #3E3C39 !important;
    background: #3E3C39 !important;
  }

  /deep/ .gender .el-radio__input.is-checked + .el-radio__label {
    color: #3E3C39;
  }

  /deep/ .gender .el-radio__inner:hover {
    border-color: #3E3C39 !important;
  }

  /deep/ .el-input__inner {
    border:1px solid rgba(187,187,187,1);
  }
</style>



// WEBPACK FOOTER //
// src/views/viewHK/MyProfile/SelfPage.vue